import dayjs from "dayjs";

export const formatTime = (time: number | string, format?: string) => {
  return dayjs(time).format(format ?? "YYYY-MM-DD HH:ss:mm");
};
